import { render } from "./ProjectInvoices.vue?vue&type=template&id=7cdc1748"
import script from "./ProjectInvoices.vue?vue&type=script&lang=js"
export * from "./ProjectInvoices.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__